export enum PagesTypes {
  PROFILE = 'PROFILE',
  AUTH = 'AUTH',
  DOC = 'DOC',
  ORDERS = 'ORDERS',
  SUPPORT_CHAT = 'SUPPORT_CHAT',
}

export enum PagesLabels {
  PROFILE = 'Профиль',
  DOC = 'Документы',
  ORDERS = 'Заявки',
  SUPPORT_CHAT = 'Запросы',
  AUTH = 'Авторизация',
}
export interface IPageData {
  title: string;
  path: string;
  label: string;
}
